
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type dialogButtonMobileRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function dialogButtonMobileRT(): TemplateResult<dialogButtonMobileRTRootProps> {
    return _createElement('div', { 'className': 'cm_search-box-root__dialog_open-button' }, [this.searchBoxDialogButton(function () {
            return _createElement('div', { 'className': 'cm_desktop-hide  cm_searchBoxDialogButton' }, _createElement('svg', {
                'className': 'icon icon-search cm_mobile-hide',
                'aria-hidden': 'true',
                'focusable': 'false'
            }, _createElement('use', { 'href': '#icon-search' })), _createElement('svg', {
                'className': 'modal__toggle-open icon icon-search cm_desktop-hide',
                'xmlns': 'http://www.w3.org/2000/svg',
                'width': '22',
                'height': '22',
                'viewBox': '0 0 22 22',
                'fill': 'none'
            }, _createElement('path', {
                'd': 'M19.2507 19.2502L14.4868 14.4863M14.4868 14.4863C15.7762 13.197 16.5005 11.4482 16.5005 9.62477C16.5005 7.80134 15.7762 6.05259 14.4868 4.76323C13.1974 3.47387 11.4487 2.74951 9.62526 2.74951C7.80183 2.74951 6.05308 3.47387 4.76372 4.76323C3.47436 6.05259 2.75 7.80134 2.75 9.62477C2.75 11.4482 3.47436 13.197 4.76372 14.4863C6.05308 15.7757 7.80183 16.5 9.62526 16.5C11.4487 16.5 13.1974 15.7757 14.4868 14.4863Z',
                'stroke': 'currentColor',
                'strokeLinecap': 'round',
                'strokeLinejoin': 'round'
            })));
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:searchBoxDialogButton"]